import request from '@/utils/request'

/**
 * 获取分页数据
 *
 * @param {*} type 消息类型 1系统通知 2奖励消息
 * @param {*} pageIndex 当前页码
 * @param {*} pageSize  每页大小
 * @export
 * @returns
 */
export function notificationList({ type, pageIndex, pageSize }) {
  return request({
    url: `/Api/Notification/List?type=${type}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'
  })
}

/**
 * 更新消息已读状态
 * @param {*} pageIndex 已读消息
 * @export
 * @returns
 */
export function notificationHaveRead(ids) {
  return request({
    url: '/Api/Notification/HaveRead',
    method: 'post',
    data: ids
  })
}
